<template>
  <div
    class="
      min-height
      user-list-main-wrapper
      cbg-white-container
      theme--light
      v-card
      user-list-wrap-box
    "
  >
    <CCol sm="12" class="pt-0">
      <div>
        <v-tabs
          v-model="tabs"
          background-color="transparent"
          class="border-bottom"
        >
          <v-tab
            v-for="(item, i) in items"
            :key="i"
            @change="changeTab(item)"
            >{{ item.tabName }}</v-tab
          >
        </v-tabs>

        <v-tabs-items v-model="tabs">
          <!-- .......... Doctor......... -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tabs === 0">
                  <subscription-reports-list-table
                    :role="'doctor'"
                    :joinOnDateRange="joinOnDateRange"
                    @removeDate="removeDate"
                  ></subscription-reports-list-table>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- .......... Pharmacy......... -->

          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tabs === 1">
                  <subscription-reports-list-table
                    :role="'pharmacy'"
                    :joinOnDateRange="joinOnDateRange"
                  ></subscription-reports-list-table>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- .......... Diagnostics ......... -->

          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tabs === 2">
                  <subscription-reports-list-table
                    :role="'diagnostics-lab'"
                    :joinOnDateRange="joinOnDateRange"
                  ></subscription-reports-list-table>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- .......... Bloodbank ......... -->

          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tabs === 3">
                  <subscription-reports-list-table
                    :role="'bloodbank'"
                    :joinOnDateRange="joinOnDateRange"
                  ></subscription-reports-list-table>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- .......... Ambulance ......... -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tabs === 4">
                  <subscription-reports-list-table
                    :role="'ambulance'"
                    :joinOnDateRange="joinOnDateRange"
                  ></subscription-reports-list-table>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- .......... Allied ......... -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <div v-if="tabs === 5">
                  <subscription-reports-list-table
                    :role="'allied'"
                    :joinOnDateRange="joinOnDateRange"
                    @removeDate="removeDate"
                  ></subscription-reports-list-table>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </CCol>
  </div>
</template> 
<script>
import { pickSvg } from "@/views/SVG";
// /Users/relife/Documents/git/admin-frontend-new/src/components/subscriptions/subscriptionReportsListTable.vue
const subscriptionReportsListTable = () =>
  import("@/components/subscriptions/subscriptionReportsListTable.vue");
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
export default {
  props: {},
  data() {
    return {
      dayJS,
      joinOnDateRange: { start: "", end: "" },
      tabs: null,
      items: [
        { tabName: "doctor" },
        { tabName: "pharmacy" },
        { tabName: "diagnostics-lab" },
        { tabName: "bloodbank" },
        { tabName: "ambulance" },
        { tabName: "allied" },
      ],
      role: "doctor",
    };
  },

  components: {
    ...pickSvg(
      "verticalDotsSVG",
      "nonverifiedUserSVG",
      "verifiedUserSVG",
      "searchSVG",
      "crossSVG"
    ),

    "subscription-reports-list-table": subscriptionReportsListTable,
  },
  methods: {
    changeTab(tab) {
      this.role = tab.tabName;
      this.joinOnDateRange = { start: "", end: "" };
    },
    removeDate() {
      this.joinOnDateRange = { start: "", end: "" };
    },
  },
  created() {
    if (this.$route.params.role) {
      this.role = this.$route.params.role;
      this.items.forEach((item, index) => {
        if (item.tabName === this.role) this.tabs = index;
      });
    }
    if (this.$route.params.selectedDate) {
      if (this.$route.params.selectedDate === "today") {
        this.joinOnDateRange.start = new Date();
        this.joinOnDateRange.end = new Date();
      } else if (this.$route.params.selectedDate === "week") {
        var firstDate = dayJS().startOf("week");
        this.joinOnDateRange.start = new Date(firstDate);
        this.joinOnDateRange.end = new Date();
      } else if (this.$route.params.selectedDate === "month") {
        var firstDate = dayJS().startOf("month");
        this.joinOnDateRange.start = new Date(firstDate);
        this.joinOnDateRange.end = new Date();
      } else if (this.$route.params.selectedDate === "custom") {
        this.joinOnDateRange.start = this.$route.params.selectedTime.start;
        this.joinOnDateRange.end = this.$route.params.selectedTime.end;
      } else {
        this.joinOnDateRange = { start: "", end: "" };
      }
    }
  },
};
</script>
<style lang="scss">
.capitalize-text {
  text-transform: capitalize;
}

.profilebox svg {
  width: 15px !important;
}
</style>
